// eslint-disable-next-line @typescript-eslint/no-explicit-any
function values(obj) {
  return Object.keys(obj).map(key => obj[key]);
}

export { values };
